"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VehicleDropOffEntity = void 0;
const BadRequestError_1 = require("../GS/BadRequestError");
const CustomerVehicleDto_1 = require("../customer-vehicles/CustomerVehicleDto");
const CustomerVehicleEntity_1 = require("../customer-vehicles/CustomerVehicleEntity");
const VehicleDropOffDto_1 = require("./VehicleDropOffDto");
const UserDto_1 = require("../users/UserDto");
const UserEntity_1 = require("../users/UserEntity");
const validators_1 = require("../GS/validators");
const SingleEntityBase_1 = require("../GS/SingleEntityBase");
const ValidationError_1 = require("../GS/ValidationError");
class VehicleDropOffEntity extends SingleEntityBase_1.SingleEntityBase {
    constructor(dependencies, vehicleDropOff) {
        super();
        this._requiredFieldsSetStatus = {
            customerVehicleId: false,
            status: false,
            droppedOffAt: false,
            datetimeConfirmedAt: false,
            customerNotes: false
        };
        this._dependencies = dependencies;
        if (vehicleDropOff === undefined) {
            this._dto = new VehicleDropOffDto_1.VehicleDropOffDto();
        }
        else if (vehicleDropOff instanceof VehicleDropOffDto_1.VehicleDropOffDto) {
            this._dto = new VehicleDropOffDto_1.VehicleDropOffDto(vehicleDropOff);
            this._clearAllRequiredFieldsSetStatuses();
            this._setIsNew(!this._dto.id);
        }
        else if (vehicleDropOff instanceof VehicleDropOffEntity) {
            this._dto = new VehicleDropOffDto_1.VehicleDropOffDto(vehicleDropOff._dto);
            this._clearAllRequiredFieldsSetStatuses();
            this._setIsNew(!this._dto.id);
        }
        else {
            throw new Error("Invalid arg");
        }
    }
    toDto() {
        return new VehicleDropOffDto_1.VehicleDropOffDto(this._dto);
    }
    getId() {
        return this._dto.id;
    }
    getCustomerVehicle() {
        if (this._dto.customerVehicleId === undefined) {
            return undefined;
        }
        if (this._dto.customerVehicle === undefined) {
            throw new Error("Cannot call getCustomerVehicle without first loading the Customer Vehicle.");
        }
        if (!this._customerVehicleEntity && this._dto.customerVehicle) {
            this._customerVehicleEntity = new CustomerVehicleEntity_1.CustomerVehicleEntity(this._dependencies, this._dto.customerVehicle);
        }
        return this._customerVehicleEntity;
    }
    setCustomerVehicle(untrustedValue) {
        let untrustedId;
        if (untrustedValue instanceof CustomerVehicleEntity_1.CustomerVehicleEntity) {
            if (untrustedValue.isNew) {
                throw new BadRequestError_1.BadRequestError("untrustedValue.isNew cannot be true.");
            }
            untrustedId = untrustedValue.getId();
        }
        else if (untrustedValue instanceof CustomerVehicleDto_1.CustomerVehicleDto) {
            untrustedId = untrustedValue.id;
        }
        else {
            throw new BadRequestError_1.BadRequestError("untrustedValue is of an invalid type.");
        }
        this.setCustomerVehicleId(untrustedId);
        if (this.hasError("locationId")) {
            return;
        }
        if (untrustedValue instanceof CustomerVehicleEntity_1.CustomerVehicleEntity) {
            this._customerVehicleEntity = untrustedValue;
        }
    }
    getCustomerVehicleId() {
        return this._dto.customerVehicleId;
    }
    setCustomerVehicleId(untrustedValue) {
        let _untrustedValue;
        this.clearError("customerVehicleId");
        this._requiredFieldsSetStatus.customerVehicleId = true;
        if (untrustedValue !== undefined &&
            untrustedValue !== null &&
            !validators_1.isInt(untrustedValue, { min: 1 })) {
            this.addError(new ValidationError_1.ValidationError("customerVehicleId", "Customer Vehicle Id is invalid."));
        }
        if (typeof untrustedValue === "string") {
            _untrustedValue = parseInt(untrustedValue, 10);
        }
        else {
            _untrustedValue = untrustedValue;
        }
        if (_untrustedValue === undefined || _untrustedValue === null) {
            this.addError(new ValidationError_1.ValidationError("customerVehicleId", "Customer Vehicle is required."));
        }
        if (!this.isNew && _untrustedValue === this._dto.customerVehicleId) {
            return;
        }
        this._dto.customerVehicleId = _untrustedValue;
        delete this._userEntity;
        this._setIsDirty(true);
    }
    getStatus() {
        return this._dto.status;
    }
    setStatus(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("status");
        this._requiredFieldsSetStatus.status = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("status", "Message Type is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("status", `Message Type has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.status) {
            return;
        }
        this._dto.status = _untrustedValue;
        this._setIsDirty(true);
    }
    getRo() {
        return this._dto.ro;
    }
    setRo(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("ro");
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("ro", "Ro is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("ro", `Ro has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.ro) {
            return;
        }
        this._dto.ro = _untrustedValue;
        this._setIsDirty(true);
    }
    getNotes() {
        return this._dto.notes;
    }
    setNotes(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("notes");
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("notes", "Notes is required."));
        }
        else {
            if (_untrustedValue.length > maxLength) {
                this.addError(new ValidationError_1.ValidationError("notes", `Notes has exceeded the maximum length (${maxLength} chr).`));
            }
        }
        if (!this.isNew && _untrustedValue === this._dto.notes) {
            return;
        }
        this._dto.notes = _untrustedValue;
        this._setIsDirty(true);
    }
    getCreatedAt() {
        return this._dto.createdAt;
    }
    getUpdatedAt() {
        return this._dto.updatedAt;
    }
    getDatetimeType() {
        return this._dto.datetimeType;
    }
    setDatetimeType(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("datetimeType");
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("dateTimeType", "Date Time Type is required."));
        }
        else {
            if (_untrustedValue.length > maxLength) {
                this.addError(new ValidationError_1.ValidationError("datetimeType", `Datetime Type has exceeded the maximum length (${maxLength} chr).`));
            }
        }
        if (!this.isNew && _untrustedValue === this._dto.datetimeType) {
            return;
        }
        this._dto.datetimeType = _untrustedValue;
        this._setIsDirty(true);
    }
    getDate() {
        return this._dto.date;
    }
    getTime() {
        return this._dto.time;
    }
    getLoaner() {
        return this._dto.loaner;
    }
    setLoaner(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("from");
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("loaner", "Loaner is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("loaner", `Loaner has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.loaner) {
            return;
        }
        this._dto.loaner = _untrustedValue;
        this._setIsDirty(true);
    }
    getCustomerNotes() {
        return this._dto.customerNotes;
    }
    setCustomerNotes(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("status");
        this._requiredFieldsSetStatus.customerNotes = true;
        this.clearError("customerNotes");
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("customerNotes", "Customer Notes is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("customerNotes", `Customer Notes has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.customerNotes) {
            return;
        }
        this._dto.customerNotes = _untrustedValue;
        this._setIsDirty(true);
    }
    getDropOffOnly() {
        return this._dto.dropOffOnly;
    }
    setDropOffOnly(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("dropOffOnly");
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("dropOffOnly", "Attachment Content Type is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("dropOffOnly", `Attachment Content Type has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.dropOffOnly) {
            return;
        }
        this._dto.dropOffOnly = _untrustedValue;
        this._setIsDirty(true);
    }
    getTimePeriod() {
        return this._dto.timePeriod;
    }
    setTimePeriod(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("timePeriod");
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("timePeriod", "Time Period is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("timePeriod", `Time Period has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.timePeriod) {
            return;
        }
        this._dto.timePeriod = _untrustedValue;
        this._setIsDirty(true);
    }
    getDroppedOffAt() {
        return this._dto.droppedOffAt;
    }
    setDroppedOffAt(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("droppedOffAt");
        this._requiredFieldsSetStatus.droppedOffAt = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("droppedOffAt", "Dropped is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("droppedOffAt", `Dropped Off At has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.droppedOffAt) {
            return;
        }
        this._dto.droppedOffAt = _untrustedValue;
        this._setIsDirty(true);
    }
    getDatetimeConfirmedAt() {
        return this._dto.datetimeConfirmedAt;
    }
    setDatetimeConfirmedAt(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("datetimeConfirmedAt");
        this._requiredFieldsSetStatus.datetimeConfirmedAt = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("datetimeConfirmedAt", "Datetime Confirmed At is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("datetimeConfirmedAt", `Datetime Confirmed At has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.datetimeConfirmedAt) {
            return;
        }
        this._dto.datetimeConfirmedAt = _untrustedValue;
        this._setIsDirty(true);
    }
    getClosedAt() {
        return this._dto.closedAt;
    }
    getUser() {
        if (this._dto.userId === undefined) {
            return undefined;
        }
        if (this._dto.user === undefined) {
            throw new Error("Cannot call getUser without first loading the User.");
        }
        if (!this._userEntity && this._dto.user) {
            this._userEntity = new UserEntity_1.UserEntity(this._dependencies, this._dto.user);
        }
        return this._userEntity;
    }
    setUser(untrustedValue) {
        let untrustedId;
        if (untrustedValue instanceof UserEntity_1.UserEntity) {
            if (untrustedValue.isNew) {
                throw new BadRequestError_1.BadRequestError("untrustedValue.isNew cannot be true.");
            }
            untrustedId = untrustedValue.getId();
        }
        else if (untrustedValue instanceof UserDto_1.UserDto) {
            untrustedId = untrustedValue.id;
        }
        else {
            throw new BadRequestError_1.BadRequestError("untrustedValue is of an invalid type.");
        }
        this.setUserId(untrustedId);
        if (this.hasError("userId")) {
            return;
        }
        if (untrustedValue instanceof UserEntity_1.UserEntity) {
            this._userEntity = untrustedValue;
        }
    }
    getUserId() {
        return this._dto.userId;
    }
    setUserId(untrustedValue) {
        let _untrustedValue;
        this.clearError("userId");
        if (untrustedValue !== undefined &&
            untrustedValue !== null &&
            !validators_1.isInt(untrustedValue, { min: 1 })) {
            this.addError(new ValidationError_1.ValidationError("userId", "User Id is invalid."));
        }
        if (typeof untrustedValue === "string") {
            _untrustedValue = parseInt(untrustedValue, 10);
        }
        else {
            _untrustedValue = untrustedValue;
        }
        if (!this.isNew && _untrustedValue === this._dto.userId) {
            return;
        }
        this._dto.userId = _untrustedValue;
        delete this._userEntity;
        this._setIsDirty(true);
    }
    loadAsync(id, expand) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (typeof id === "string") {
                    if (!validators_1.isInt(id, { min: 1 })) {
                        throw new BadRequestError_1.BadRequestError("ID is not valid.");
                    }
                    id = parseInt(id, 10);
                }
                this._setState("busy");
                this._emit("before-loadAsync");
                this._dto = yield this._dependencies.vehicleDropOffDatastore
                    .getAsync(id, expand);
                this._setIsNew(false);
                this._setIsDirty(false);
                this._clearAllRequiredFieldsSetStatuses();
                this.clearErrors();
                this._emit("after-loadAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    saveAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                this._emit("before-saveAsync");
                if (!this.allRequiredFieldsSet) {
                    const fields = Object.entries(this._requiredFieldsSetStatus)
                        .filter(([, isSet]) => !isSet).map(([field]) => field);
                    throw new Error(`The following required fields were never set: ${fields.join(", ")}`);
                }
                if (!this.canSave) {
                    throw new Error("Vehicle Drop Off is not in a valid state.");
                }
                let dto = this.toDto();
                if (this.isNew) {
                    dto = yield this._dependencies.vehicleDropOffDatastore
                        .addAsync(this._dto);
                }
                else if (this.isDirty) {
                    dto = yield this._dependencies.vehicleDropOffDatastore
                        .updateAsync(this._dto);
                }
                this._dto.id = dto.id;
                this._dto.createdAt = dto.createdAt;
                this._dto.updatedAt = dto.updatedAt;
                this._setIsNew(false);
                this._setIsDirty(false);
                this._emit("after-saveAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    deleteAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                this._emit("before-deleteAsync");
                if (!this.canDelete) {
                    throw new Error("Vehicle Drop Off cannot be deleted.");
                }
                if (!this.isNew) {
                    yield this._dependencies.vehicleDropOffDatastore.removeAsync(this.getId());
                }
                this._emit("after-deleteAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
}
exports.VehicleDropOffEntity = VehicleDropOffEntity;
//# sourceMappingURL=VehicleDropOffEntity.js.map